import React from "react";
import {
  BottomNavigationMobileButtonWrapper,
  BottomNavigationMobileIconWrapper,
  BottomNavigationMobileLabelWrapper,
  BottomNavigationMobileLinkWrapper
} from "./BottomBarNavigationWrapper.js";
import PropTypes from "prop-types";
import { TrackingUtils } from "../../../utils/index.js";
import SVGIconV3 from "../../common/SVGIcon/SVGIconV3.js";
import { MenuSelectors } from "../../../redux/selectors/index.js";
import { MenuActionCreators } from "../../../redux/action-creators/index.js";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

const BottomBarNavigationItem = props => {
  const {
    onClick,
    dataTestId,
    googleAnalyticsLabel,
    iconLabel,
    iconColor,
    itemType = "button",
    href,
    children
  } = props;

  const dispatch = useDispatch();
  const quickLinksInnerMenuVisible = useSelector(
    MenuSelectors.quickLinksInnerMenuVisible
  );

  const handleButtonClick = e => {
    handleDrawerToggle();
    e.preventDefault();
    e.stopPropagation();
    onClick(e);
  };

  const handleDrawerToggle = () => {
    sendGoogleAnalytics(googleAnalyticsLabel);

    if (!!quickLinksInnerMenuVisible) {
      dispatch(MenuActionCreators.hideQuickLinksInnerMenu());
      dispatch(
        MenuActionCreators.setFavouriteSportsRunningInsideInnerMenu(false)
      );
    }
  };

  const sendGoogleAnalytics = label => {
    TrackingUtils.sendAnalytics({
      dataCategory: "bottom navigation web",
      dataAction: "click",
      dataLabel: `uc-bottom-navigation-${label}`
    });
  };

  return (
    <>
      {itemType === "button" ? (
        <BottomNavigationMobileButtonWrapper
          data-testid={dataTestId}
          onClick={e => handleButtonClick(e)}
        >
          <BottomNavigationMobileIconWrapper>
            <SVGIconV3
              iconName={iconLabel}
              color={iconColor ?? "white"}
              height="1.8rem"
              width="1.8rem"
            />
          </BottomNavigationMobileIconWrapper>
          <BottomNavigationMobileLabelWrapper>
            {children}
          </BottomNavigationMobileLabelWrapper>
        </BottomNavigationMobileButtonWrapper>
      ) : (
        <BottomNavigationMobileLinkWrapper
          data-testid={dataTestId}
          href={href}
          onClick={e => handleDrawerToggle(e)}
        >
          <BottomNavigationMobileIconWrapper>
            <SVGIconV3
              iconName={iconLabel}
              color={iconColor ?? "white"}
              height="1.8rem"
              width="1.8rem"
            />
          </BottomNavigationMobileIconWrapper>
          <BottomNavigationMobileLabelWrapper>
            {children}
          </BottomNavigationMobileLabelWrapper>
        </BottomNavigationMobileLinkWrapper>
      )}
    </>
  );
};

BottomBarNavigationItem.propTypes = {
  iconLabel: PropTypes.string,
  iconColor: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node,
  dataTestId: PropTypes.string,
  googleAnalyticsLabel: PropTypes.string,
  itemType: PropTypes.string,
  href: PropTypes.string
};

export default React.memo(BottomBarNavigationItem);
